import { createBundle } from 'widget/Common';

// ----- Login 模块 -----
import LoginView from 'bundle-loader?lazy&name=LoginView!pages/Login/LoginView';
import WxLoginTipView from 'bundle-loader?lazy&name=WxLoginTipView!pages/Login/WxLoginTip/WxLoginTipView';
import GoogleLoginTipView from 'bundle-loader?lazy&name=GoogleLoginTipView!pages/Login/GoogleLoginTip/GoogleLoginTipView';
import FindPasswordView from 'bundle-loader?lazy&name=FindPasswordView!pages/Login/FindPassword/FindPasswordView';
import MiddlePageView from 'bundle-loader?lazy&name=MiddlePageView!pages/Login/MiddlePage/MiddlePageView';
import WorkWxVerifyView from 'bundle-loader?lazy&name=WorkWxVerifyView!pages/Login/WorkWxVerify/WorkWxVerifyView';

import LoginCommonTipsView from 'bundle-loader?lazy&name=LoginCommonTipsView!pages/Login/CommonTips/CommonTipsView';

const RouterConfig = [
  // ----- 登录 -----
  {
    path: '/login',
    title: '登录',
    component: () => {
      return createBundle(LoginView);
    }
  },
  {
    path: '/login/wechatTip',
    title: '微信登录',
    component: () => {
      return createBundle(WxLoginTipView);
    }
  },
  {
    path: '/login/googleTip',
    title: '邮箱登录',
    component: () => {
      return createBundle(GoogleLoginTipView);
    }
  },
  {
    path: '/login/findPassword',
    title: '找回密码',
    component: () => {
      return createBundle(FindPasswordView);
    }
  },
  {
    path: '/login/middlePage',
    title: '中间页',
    component: () => {
      return createBundle(MiddlePageView);
    }
  },
  {
    path: '/login/CommonTips',
    title: '温馨提示',
    component: () => {
      return createBundle(LoginCommonTipsView);
    }
  },
  {
    path: '/login/workWxVerify',
    title: '企业微信二次验证',
    component: () => {
      return createBundle(WorkWxVerifyView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/Login/RouterConfig.js